/**
 * Shared 3D-artifact resolution (2026-08-01/02): one fetch path for BOTH the in-chat
 * preview modal (the default canvas — Miles directive: popup first, full page on demand)
 * and the /preview/3d/:id expanded page. The resolver returns scene HTML inline
 * (owner-gated server-side), so no storage URL, CORS grant, or frame-src exception is
 * ever needed client-side.
 */
import { getAuth } from 'firebase/auth';

export const CF_BASE_URL = 'https://us-central1-tensile-tenure-453409-k3.cloudfunctions.net';

/** Pure link/route helpers live in fileLinks.ts (no firebase import) — re-exported
 *  here so existing callers keep working. */
export {
  THREE_D_PREVIEW_ROUTE_PREFIX,
  threeDArtifactIdFromRoute,
  sceneAttachmentFromUrl,
  fileAttachmentFromUrl,
} from './fileLinks';

export interface ResolvedScene {
  artifactId: string;
  title: string;
  name: string;
  html: string;
}

export async function resolveThreeDScene(artifactId: string): Promise<ResolvedScene> {
  const user = getAuth().currentUser;
  if (!user) throw new Error('auth-required');
  const token = await user.getIdToken();
  const resp = await fetch(`${CF_BASE_URL}/prest0nResolve3dPreview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ artifactId }),
  });
  if (!resp.ok) throw new Error(resp.status === 404 ? 'not-found' : `resolver-${resp.status}`);
  return (await resp.json()) as ResolvedScene;
}
